import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import Header from './series-lead-elements/header';
import WhatIsInside from './series-lead-elements/what-is-inside';
import Companies from './series-lead-elements/companies';
import Form from './series-lead-elements/form';
import Footer from './series-lead-elements/footer';
import theme from '../../../assets/stylesheets/_settings.global.scss';

const Div = styled.div`
  display: flex;
  flex-direction: column;
`;

export default function Root(props) {
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });
  const themeState = {
    ...props,
    ...theme,
    isPortrait,
  };

  const header = {
    title: 'Livewire’s most tipped stocks for 2020',
    buttonText: 'download my 2020 ebook',
    desc: 'We reached out to 9 leading fund managers and 7000 Australian '
      + 'investors and asked them to share their #1 stock idea for the year '
      + 'ahead. For this special Livewire eBook we have distilled the '
      + 'fundies’ and readers ideas for you, to bring you Livewire’s most '
      + 'tipped stocks for 2020.',
  };

  const inside = {
    title: '29 top stock ideas from fund managers and readers',
    desc: 'At the start of 2019, Livewire published three separate lists of stock ideas. '
      + 'By the time the year was out, the first list had gained 59% on average, '
      + 'the second was up 50% on average, and the third was up 43% on average. '
      + 'In the list for 2020 you receive our:',
    bullets: [
      'The 10 most tipped big caps',
      'The 10 most tipped small caps',
      '#1 stock pick for 2020 from last years top fund managers',
    ],
  };

  return (
    <ThemeProvider theme={themeState}>
      <Div>
        <Header header={header} />
        <WhatIsInside inside={inside} />
        <Companies ebookName={header.title} />
        <Form ebookName="2020 most tipped stocks" />
        <Footer />
      </Div>
    </ThemeProvider>
  );
}

/* eslint-disable react/no-unused-prop-types */
Root.propTypes = {
  logo: PropTypes.string.isRequired,
  cover: PropTypes.string.isRequired,
  ebook: PropTypes.arrayOf(PropTypes.string).isRequired,
  partners: PropTypes.arrayOf(PropTypes.string).isRequired,
};
/* eslint-enable react/no-unused-prop-types */
